import React from 'react'
import { observer,inject } from 'mobx-react'

import classNames from 'classnames'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import Button from 'material-ui/Button'
import Dialog from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import T from 'i18n-react'
import Avatar from 'material-ui/Avatar'

import 'react-modal-video/css/modal-video.min.css'
import ModalVideo from 'react-modal-video'
import IMAGE_ARNE from '../arne.jpg'
import IMAGE_ANTONIA from '../antonia.png'
import List, { ListItem, ListItemSecondaryAction, ListItemText } from 'material-ui/List'
import Checkbox from 'material-ui/Checkbox'
import Icon from 'material-ui/Icon'


@inject('store','ui') @observer
class Explanation extends React.Component {
  componentWillMount () {
    this.props.ui.catalog.checkExplanation()
  }

  render () {
    const { classes } = this.props, ui = this.props.ui.catalog
    const videos = [
      {id:'5cJSBJKHE8c',name:'Suchfunktion'},
      {id:'LG48oLRjgj4',name:'Sammlung'},
      {id:'INGIgPEtbWc',name:'QR Codes'}
    ]
    return (
      <div>
       <Dialog onClose={ui.handleCloseExplanationVideoSelect} aria-labelledby="simple-dialog-title" open={ui.openExplanationVideoSelect}>
        <div className={classes.container}>

         <div className={classes.avatarContainer}>
          <Avatar size={50} src={IMAGE_ANTONIA} className={classes.avatar} />
          <Avatar size={50} src={IMAGE_ARNE} className={classes.avatar} />
         </div>

         <Divider />

         <Typography component="p" style={{fontSize:'1.1rem',padding:'1.5rem',}}>
          Wir sind Antonia und Arne und wollen dich bekannt machen mit Musik21.ch.
          Zu den Themen Suchfunktion, Sammlung und Umgang mit QR-Codes kannst Du in den folgenden Videos Anregungen holen.
         </Typography>

        </div>
        <div className={classes.videoButtons}>
         {videos.map((video,i) => {
          return <Button key={'video-'+i} style={{flex:1}} color="primary" onClick={ui.openExplanationVideo.bind(this,video.id)}>
           <Icon>play_arrow</Icon>
           {video.name}
          </Button>
         })}
        </div>
        <Divider />

        <Typography component="p" style={{fontSize:'1.1rem',padding:'1.5rem',}}>
         Wir bieten auch eine Weiterbildung zur Plattform an - <a href="https://www.phbern.ch/weiterbildung/17118284-onlineplattform-wwwmusik21ch">hier aufrufen</a>
        </Typography>

        <Divider />

        <List>
         <ListItem dense button onClick={ui.toggleShowExplanationAgain}>
         <ListItemText primary="Nicht mehr anzeigen" />
         <ListItemSecondaryAction>
          <Checkbox
           checked={ui.dontShowExplanationAgain}
           disableRipple
           onChange={ui.toggleShowExplanationAgain}
          />
         </ListItemSecondaryAction>
        </ListItem>
       </List>

       </Dialog>

       <ModalVideo
        channel='youtube'
        isOpen={ui.openExplanation}
        videoId={ui.currentExplanationVideoId}
        onClose={ui.closeExplanationVideo}
       />

      </div>
    )
  }
}




const styles = theme => ({
 container:{
   minWidth:300,
 },
 avatarContainer:{
  textAlign:'center',
 },
 avatar:{
   display:'inline-block',
   width:70,
   height:70,
   margin:'1.5rem'
 },
 videoButtons:{
   display:'flex'
 }
})


Explanation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(Explanation)



// WEBPACK FOOTER //
// ./src/components/explanation.js